import { render, staticRenderFns } from "./AutoThreewaySwitchWidget.vue?vue&type=template&id=4786587f&scoped=true"
import script from "./AutoThreewaySwitchWidget.vue?vue&type=script&lang=js"
export * from "./AutoThreewaySwitchWidget.vue?vue&type=script&lang=js"
import style0 from "./AutoThreewaySwitchWidget.vue?vue&type=style&index=0&id=4786587f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4786587f",
  null
  
)

export default component.exports